var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Check"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.81101 8.30719C4.51666 8.01576 4.04179 8.01814 3.75037 8.3125C3.45894 8.60686 3.46132 9.08173 3.75568 9.37315L7.59165 12.9329C7.9001 13.2383 8.40257 13.2189 8.68654 12.8906L14.8175 5.80319C15.0885 5.48992 15.0542 5.01628 14.741 4.74529C14.4277 4.4743 13.9541 4.50857 13.6831 4.82184L8.07691 11.3026L4.81101 8.30719Z",
    fill: "#A461D8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.f796c46e5d19665f8d51f51836484f1e.svg";
export { ForwardRef as ReactComponent };